/* 

Copyright© Celligence International, LLC - 2023

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import "./Assets/Fonts/HoneyScript.ttf";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";

// checks if we have a valid entry of <div id="root"><div>
// the entry point was placed into a conditional at index.html to handle browser version catching correctly
const entryPoint = document.getElementById('root');

if (entryPoint) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
